(function() { window.GUID_45d21400_03bf_4800_9316_94b59dab2c61 = { getGuid: function() { return "45d21400-03bf-4800-9316-94b59dab2c61"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-stat-compare-against-others",
                        callback: (accordion, e) => {
                            var _a;
                            const isPremiumLocked = accordion.$Header.hasClass("is-premium-locked");
                            const $emptyStateElement = accordion.$Content.find(`#StatCompareAgainstOthersSectionViewModelNoData-${accordion.ContentId}`);
                            const $gameTypeNameInput = accordion.$Content.find(`#StatCompareAgainstOthersSectionViewModelGameTypeName-${accordion.ContentId}`);
                            const gameTypeName = (_a = $gameTypeNameInput.val()) !== null && _a !== void 0 ? _a : "";
                            if ($emptyStateElement.length) {
                                if (gameTypeName.trim() === "") {
                                    $emptyStateElement.text(JSRess.These2PlayersHaveNoCommonOpponent);
                                }
                                else {
                                    $emptyStateElement.html(CS.Helper.formatString(JSRess.These2PlayersHaveNoCommonOpponentIn, gameTypeName));
                                }
                                return;
                            }
                            const $dataInput = $(`#StatCompareAgainstOthersSectionViewModel-${accordion.ContentId}`);
                            if (!$dataInput.length) {
                                return;
                            }
                            const rawData = $dataInput.val();
                            if (rawData == null ||
                                (typeof rawData === "string" && rawData.trim() === "")) {
                                return;
                            }
                            const data = JSON.parse(rawData);
                            const playerColors = CS.Helper.DataVisualizationHelper.getColors(2);
                            const _opponentColors = [
                                CS.Helper.DataVisualizationHelper.MUI_PALETTE.lightGreen[500],
                                CS.Helper.DataVisualizationHelper.MUI_PALETTE.yellow[500],
                                CS.Helper.DataVisualizationHelper.MUI_PALETTE.deepPurple[300],
                                CS.Helper.DataVisualizationHelper.MUI_PALETTE.red[500],
                                CS.Helper.DataVisualizationHelper.MUI_PALETTE.teal[500],
                            ];
                            const opponentsCount = data.Entries.length;
                            const namePlayerA = data.PersonaPlayerA.PersonaName;
                            const namePlayerB = data.PersonaPlayerB.PersonaName;
                            const opponentsNames = data.Entries.map((entry) => entry.Opponent.PersonaName);
                            const $introductionContainer = accordion.$Container.find(`#StatCompareAgainstOthersSectionViewModelIntroduction-${accordion.ContentId}`);
                            if ($introductionContainer.length) {
                                let introductionHtml = "";
                                if (opponentsCount == 1) {
                                    introductionHtml = CS.Helper.formatString(JSRess.XAndYHaveBothPlayerdAgainstThisOpponentInZ, namePlayerA, namePlayerB, gameTypeName);
                                    introductionHtml += `${opponentsNames[0]}`;
                                }
                                else if (opponentsCount > 1) {
                                    introductionHtml = CS.Helper.formatString(JSRess.XAndYHaveBothPlayerdAgainstThisZOpponentInA, namePlayerA, namePlayerB, opponentsCount, gameTypeName);
                                    introductionHtml += `<ul>${opponentsNames
                                        .map((name) => `<li><strong><i>${name}</i></strong></li>`)
                                        .join("")}</ul>`;
                                }
                                if (introductionHtml != "") {
                                    $introductionContainer.html(introductionHtml);
                                    $introductionContainer.show();
                                }
                            }
                            const $summaryExplanation = $(`#StatCompareAgainstOthersSectionViewModelGaugeChartCanvasExplanation-${accordion.ContentId}`);
                            if ($summaryExplanation.length && !isPremiumLocked) {
                                const averagePercentPlayerA = `<strong style="color: ${playerColors[0]};">${data.WinsPercentAveragePlayerA.toFixed(2)}%</strong>`;
                                const averagePercentPlayerB = `<strong style="color: ${playerColors[1]};">${data.WinsPercentAveragePlayerB.toFixed(2)}%</strong>`;
                                const averagePercentComparison = `${averagePercentPlayerA} VS ${averagePercentPlayerB}`;
                                const differentAverage = data.WinsPercentAveragePlayerA != data.WinsPercentAveragePlayerB;
                                let summaryExplanationHtml;
                                if (differentAverage) {
                                    let winnerHtml;
                                    if (data.WinsPercentAveragePlayerA > data.WinsPercentAveragePlayerB) {
                                        winnerHtml = `<i><strong style="color: ${playerColors[0]};">${data.PersonaPlayerA.PersonaName}</strong></i>`;
                                        // winnerHtml = `<i><strong style="color: white;">${data.PersonaPlayerA.PersonaName}</strong></i>`;
                                    }
                                    else {
                                        winnerHtml = `<i><strong style="color: ${playerColors[1]};">${data.PersonaPlayerB.PersonaName}</strong></i>`;
                                        // winnerHtml = `<i><strong style="color: white;">${data.PersonaPlayerB.PersonaName}</strong></i>`;
                                    }
                                    if (gameTypeName) {
                                        summaryExplanationHtml = CS.Helper.formatString(JSRess.XHasAHigherWinRateAgainstTheseYOpponentsInZ, winnerHtml, data.PersonasOpponents.length, gameTypeName);
                                    }
                                    else {
                                        summaryExplanationHtml = `<div class="winner-name">${CS.Helper.formatString(JSRess.XHasAHigherWinRateAgainstTheseYOpponents, winnerHtml, data.PersonasOpponents.length)} (${averagePercentComparison})</i>`;
                                    }
                                }
                                else {
                                    if (gameTypeName) {
                                        summaryExplanationHtml = `${CS.Helper.formatString(JSRess.OnAverageBothPlayersWinTheSamePecentageOfTimesAgainstTheseXOpponentsInY, data.PersonasOpponents.length, gameTypeName)} (${averagePercentComparison})`;
                                    }
                                    else {
                                        summaryExplanationHtml = `${CS.Helper.formatString(JSRess.OnAverageBothPlayersWinTheSamePecentageOfTimesAgainstTheseXOpponents, data.PersonasOpponents.length)} (${averagePercentComparison})`;
                                    }
                                }
                                $summaryExplanation.html(summaryExplanationHtml);
                            }
                            StatCompareAgainstOthersSection.SetContentV2(accordion, playerColors, data);
                        },
                    });
                    let StatCompareAgainstOthersSection;
                    (function (StatCompareAgainstOthersSection) {
                        function SetContentV2(accordion, playerColors, data) {
                            var _a;
                            try {
                                const containerElementId = `BarChartSectionContainerElement-${accordion.ContentId}`;
                                const legentContainerElementId = `BarChartSectionLegendContainerElement-${accordion.ContentId}`;
                                const $canvas = accordion.$Content.find("canvas.StatCompareAgainstOthersCanvas");
                                if (!$canvas.length)
                                    return;
                                $canvas.css({
                                    display: "none",
                                });
                                const $chartContainer = $canvas.closest(".canvas-container");
                                if (!$chartContainer.length)
                                    return;
                                // const $legendContainer = $(
                                //   `<svg id="${legentContainerElementId}" class="stat-container__legend"></svg>`
                                // );
                                // $chartContainer.before($legendContainer);
                                $chartContainer.addClass("stat-container__chart");
                                $chartContainer.attr("id", containerElementId);
                                accordion.CustomData = {
                                    scrollableBarChart: null,
                                };
                                if (!data || !((_a = data.Entries) === null || _a === void 0 ? void 0 : _a.length))
                                    return;
                                const datapoints = [];
                                const oneDecimalPlaceString = (value) => {
                                    let result = value.toFixed(1).toString().replace(",", ".");
                                    if (result.endsWith(".0")) {
                                        result = result.replace(".0", "");
                                    }
                                    return result;
                                };
                                data.Entries.forEach((entry, index) => {
                                    let valueRatioPercentageString = "";
                                    let stackedValueRatioPercentageString = "";
                                    const value = entry.Datasets[0].WinsPercent;
                                    const stackedValue = entry.Datasets[1].WinsPercent;
                                    if (value == 0 && stackedValue == 0)
                                        return;
                                    if (value == 0 || stackedValue == 0) {
                                        if (value == 0) {
                                            valueRatioPercentageString = "0";
                                            stackedValueRatioPercentageString = "100";
                                        }
                                        else {
                                            valueRatioPercentageString = "100";
                                            stackedValueRatioPercentageString = "0";
                                        }
                                    }
                                    else {
                                        const total = value + stackedValue;
                                        const valueRatio = value / total;
                                        const valueRatioPercentage = valueRatio * 100;
                                        valueRatioPercentageString = valueRatioPercentage.toFixed(0);
                                        stackedValueRatioPercentageString = (100 - Number(valueRatioPercentageString)).toFixed(0);
                                    }
                                    const datapoint = {
                                        Id: entry.PersonaIdPlayerA,
                                        Key: entry.PersonaIdOpponent,
                                        IsStacked: false,
                                        SortDirection: CS.Enumeration.SortDirection.Ascending,
                                        Name: entry.PlayerA.PersonaName,
                                        Avatar: entry.Opponent.PersonaImgUrl,
                                        Value: valueRatioPercentageString,
                                        DisplayValue: `${oneDecimalPlaceString(entry.Datasets[0].WinsPercent)}%`,
                                        StackedDisplayValue: `${oneDecimalPlaceString(entry.Datasets[1].WinsPercent)}%`,
                                        StackedValue: stackedValueRatioPercentageString,
                                        SortValue: "0",
                                        XAxisBottomLabel: `VS – ${entry.Opponent.PersonaName}`,
                                        XAxisTopLabel: `${entry.Datasets[0].Wins} / ${entry.Datasets[0].Wins + entry.Datasets[0].Losses}`,
                                        XAxisTopLabelStacked: `${entry.Datasets[1].Wins} / ${entry.Datasets[1].Wins + entry.Datasets[1].Losses}`,
                                        OpponentFallbackUrl: entry.OpponentFallbackUrl,
                                    };
                                    const stackedDatapoint = {
                                        Id: `${entry.PersonaIdPlayerA}-stacked`,
                                        Key: entry.PersonaIdOpponent,
                                        Value: stackedValueRatioPercentageString,
                                        StackedValue: "",
                                        IsStacked: true,
                                        SortDirection: CS.Enumeration.SortDirection.Ascending,
                                        SortValue: "0",
                                        Name: entry.PlayerA.PersonaName,
                                        Avatar: entry.Opponent.PersonaImgUrl,
                                        XAxisBottomLabel: `VS – ${entry.Opponent.PersonaName}`,
                                        XAxisTopLabel: `${oneDecimalPlaceString(entry.Datasets[1].WinsPercent)}%`,
                                        OpponentFallbackUrl: entry.OpponentFallbackUrl,
                                    };
                                    datapoints.push(datapoint);
                                    datapoints.push(stackedDatapoint);
                                });
                                // accordion.CustomData.scrollableBarChart.init();
                                const colors = CS.Helper.DataVisualizationHelper.getColors(2);
                                const nonStackedDatapoints = datapoints.filter((datapoint) => !datapoint.IsStacked);
                                if (!nonStackedDatapoints.length)
                                    return;
                                const $container = accordion.$Content.find(`.cs-compared-stats__body`);
                                nonStackedDatapoints.forEach((datapoint) => {
                                    const datapointId = `datapoint-${datapoint.Id}-${CS.Helper.generateRandomId()}`;
                                    const datapointBodyId = `${datapointId}-body`;
                                    const datapointHeaderId = `${datapointId}-header`;
                                    const html = `
            <div id="${datapointId}" class="datapoint stat-container">
                <div id="${datapointHeaderId}" class="datapoint-header">
                    <div class="opponent">
                        <div class="datapoint-avatar">
                            <img src="${datapoint.Avatar}" onerror="this.onerror=null;this.src='${datapoint.OpponentFallbackUrl}'" />
                        </div>
                        <div class="datapoint-name">
                            ${datapoint.XAxisBottomLabel}
                        </div>
                    </div>
                    <div class="values">
                        <div class="datapoint-value">
                            <div class="value__header">
                                ${datapoint.DisplayValue}
                            </div>
                            <div class="value__body">
                                ${datapoint.XAxisTopLabel}
                            </div>
                        </div>
                        <div class="datapoint-value">
                            <div class="value__header">
                                ${datapoint.StackedDisplayValue}
                            </div>
                            <div class="value__body">
                                ${datapoint.XAxisTopLabelStacked}
                            </div>
                        </div>
                    </div>
                </div>
                <div id="${datapointBodyId}" class="datapoint-body">
                </div>
            </div>
          `;
                                    $container.append(html);
                                    const extractedDatapoints = [
                                        {
                                            stackId: "0",
                                            seriesId: "A",
                                            value: Number(datapoint.Value),
                                            isStacked: false,
                                        },
                                        {
                                            stackId: "0",
                                            seriesId: "B",
                                            value: Number(datapoint.StackedValue),
                                            isStacked: true,
                                        },
                                    ];
                                    const comparedValueBarChart = new CS.Controls.ComparedValueBarChart({
                                        colors: colors,
                                        containerElementId: datapointBodyId,
                                        datapoints: extractedDatapoints,
                                    });
                                    comparedValueBarChart
                                        .init()
                                        .then(() => {
                                        console.log("ComparedValueBarChart.init() done");
                                    })
                                        .catch((error) => {
                                        console.log("ComparedValueBarChart.init() error", error);
                                    });
                                });
                            }
                            catch (error) {
                                console.error(error);
                            }
                        }
                        StatCompareAgainstOthersSection.SetContentV2 = SetContentV2;
                    })(StatCompareAgainstOthersSection = WallSections.StatCompareAgainstOthersSection || (WallSections.StatCompareAgainstOthersSection = {}));
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=stat-compare-against-others.js.map
